module.exports = __webpack_public_path__ + "static/media/sensable_47.a55a1db9.png";